import React, { useEffect, useMemo, useRef } from 'react'
import links from 'links'
import localStorage from 'local-storage'
import { closeNotification, openNotification } from 'notifications'
import { usePathname } from 'router'

import { constants } from 'helpers'

import { useDevice } from 'device'
import { useProductGiftPromo } from 'modules/products'

import freeLuxeTravelBagMobile from './images/free-luxe-travel-bag-mobile.png'
import freeLuxeTravelBagDesktop from './images/free-luxe-travel-bag-desktop.png'


const applicablePagePaths = [
  links.giftSets.colognes,
  links.giftSets.perfumes,
  links.shop.accessories,
  links.shop.bathBody,
  links.shop.candlesHomeScents,
  links.shop.colognes,
  links.shop.perfumes,
  links.shop.scentbirdCases,
  links.shop.theEdit,
  links.subscription.colognes,
  links.subscription.main,
  links.subscription.perfumes,
]
  .map((link) => link.replace('(.*)', '').replace(':slug', ''))
  .join('|')

const applicablePagePathRegExp = new RegExp(`^(${applicablePagePaths})`)

const handleNotificationClose = () => {
  localStorage.setItem(constants.localStorageNames.giftWithSpendThresholdShown, true)
}

const GiftWithSpendThresholdStaticNotification: React.FC = () => {
  const notificationIdRef = useRef<number>(null)

  const path = usePathname()

  const { isMobile } = useDevice()

  const { subTotal, isFetching } = useProductGiftPromo()

  const isApplicablePath = useMemo(() => {
    return applicablePagePathRegExp.test(path)
  }, [ path ])

  useEffect(() => {
    const notificationWasShown = localStorage.getItem(constants.localStorageNames.giftWithSpendThresholdShown)

    if (notificationWasShown || isFetching || !isFetching && !subTotal) {
      return
    }

    if (!isApplicablePath) {
      if (notificationIdRef.current) {
        closeNotification(notificationIdRef.current)
        notificationIdRef.current = null
      }

      return
    }

    if (notificationIdRef.current) {
      return
    }

    notificationIdRef.current = openNotification('giftWithSpendThreshold', {
      image: isMobile ? freeLuxeTravelBagMobile : freeLuxeTravelBagDesktop,
      name: 'Scentbird luxe travel bag',
      staticMode: true,
      threshold: subTotal.amountCents,
      onClose: handleNotificationClose,
    })
  }, [ isApplicablePath, subTotal, isFetching, isMobile ])

  return null
}

export default GiftWithSpendThresholdStaticNotification
